<template>
  <div class="relative mt-8 rounded-app bg-white p-8 shadow-md">
      <div class="gap-4 md:mb-8 md:grid md:grid-cols-3">

        <div class="relative my-4 md:my-0">
          <InputCareers
              id="role"
              v-model:value="form.role"
              :errors="errors.role || []"
              :label="__('Role')"
              :placeholder="__('Search here...')"
              required
              is-new-options-allowed
              @update:value="updateStdJobTitle"
          />
        </div>

        <div class="my-4 md:my-0">
          <label class="mb-2 block text-sm text-[#58585E]"
          >{{ __('Contract Type') }} *</label
          >
          <FormSingleselect
              v-model="form.contract_type"
              :errors="errors.contract_type || []"
              :values="form.options.contract_type"
              :clearable="true"
              @clear="form.contract_type = null"
              type="static"
              required
          />
        </div>

        <div class="my-4 md:my-0">
          <label class="mb-2 block text-sm text-[#58585E]"
          >{{ __('Assign to recruiter') }} *</label
          >
          <FormSingleselect
              v-model="form.recruiter"
              :values="form.options.recruiters"
              :errors="errors.recruiter || []"
              :clearable="true"
              @clear="form.recruiter = null"
              type="static"
              required
          />
        </div>

      </div>

      <div class="gap-4 md:mb-8 md:grid md:grid-cols-1">
        <VisualEditor
            v-model="form.description"
            :label="__('What the job involves')"
        />
      </div>
    <div class="flex justify-end">
      <Button
          :content="__('Cancel')"
          type="button"
          :disabled="isLoading"
          variation="outline"
          @click="onCancel"
          value="Cancel"
          class="ml-2"
      />
      <Button
          :content="btnLabel"
          type="submit"
          :disabled="isLoading"
          variation="fill"
          @click="onSubmit"
          value="Post"
          class="ml-2"
      />
    </div>


  </div>
</template>

<script setup>

import {computed, reactive, watch} from 'vue';
import {Button, FormSingleselect, Input, VisualEditor} from '../../../../components/global';
import { __ } from "../../../../helpers";
import { InputCareers } from "../../../../components/form/input-careers";
import axios from "axios";
import { useLoading } from "vue-loading-overlay";
import { useToast } from "vue-toastification";

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  isLoading: {
    type: Boolean,
    required: true
  },
  action: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['update:modelValue','submit','cancel']);
const form = reactive({ ...props.modelValue });
const $loading = useLoading();
const toast = useToast();

const btnLabel = computed( () => {
  switch(props.action) {
    case "create":
      return __('Post requisition');
    default:
      return __('Update requisition');
  }
})

watch(() => props.modelValue, newVal => {
  Object.assign(form, newVal);
});

watch(form, newForm => {
  emit('update:modelValue', { ...newForm });
}, { deep: true });

function onSubmit() {
  emit('submit');
}

function onCancel() {
  emit('cancel');
}


async function updateStdJobTitle(value) {
  if (!value) {
    return;
  }
  if (value.id === 'custom-option') {
    form.role = await createStandardisedTitle(value.name);
  }
}

const createStandardisedTitle = async (value) => {
  const loader = $loading.show();

  try {
    const response = await axios.post(
        route('redesign.company.stdtitle.create'),
        {
          name: value
        }
    );
    toast.success(response.data.message);
    return { id: response.data.id, name: value };
  } catch (err) {
    console.error(err);
  } finally {
    loader.hide();
  }
};

</script>
